import {IntegrationType} from '../../../shared/enums/integration-type.enum';
import {datadogSample} from "./cstmSmry.sample/datadog";
import {newRelicSample, newRelicViewSample} from "./cstmSmry.sample/newRelic";
import {jenniferSample, jenniferViewSample} from "./cstmSmry.sample/jennifer";
import {dynatraceSample, dynatraceViewSample } from './cstmSmry.sample/dynatrace';
import {standardSample, standardViewSample } from './cstmSmry.sample/standard';
import {sambaSample, sambaViewSample } from './cstmSmry.sample/samba';
import {watcherSample, watcherViewSample} from './cstmSmry.sample/watcher';
import {scouterSample} from "./cstmSmry.sample/scouter";
import {whatapSample} from "./cstmSmry.sample/whatap";
import {jiraSample, jiraViewSample } from './cstmSmry.sample/jira';
import {freshdeskSample, freshdeskViewSample } from './cstmSmry.sample/freshdesk';
import {jiraSoftwareSample, jiraSoftwareViewSample} from './cstmSmry.sample/jira_software';
import {opsnowSample, opsnowViewSample } from './cstmSmry.sample/opsnow';
import {iotOpsSample, iotOsViewSample} from './cstmSmry.sample/iotops';
import {devOsSample, devOsViewSample} from './cstmSmry.sample/devos';
import {sentryMetricAlertSample, sentryMetricAlertViewSample} from './cstmSmry.sample/sentry_metric_alert';
import { sentryIssueAlertSample, sentryIssueAlertViewSample } from './cstmSmry.sample/sentry_issue_alert';
import { sentryInstallationSample, sentryInstallationViewSample } from './cstmSmry.sample/sentry_installation';
import { sentryIssuesSample, sentryIssuesViewSample } from './cstmSmry.sample/sentry_issues';
import { sentryCommentsSample, sentryCommentsViewSample } from './cstmSmry.sample/sentry_comments';
import { sentryErrorsSample, sentryErrorsViewSample } from './cstmSmry.sample/sentry_errors';

export const custmSmryUseItgr = [IntegrationType.DATADOG
    , IntegrationType.NEWRELIC
    , IntegrationType.JENNIFER5
    , IntegrationType.PROMETHEUS
    , IntegrationType.DYNATRACE
    , IntegrationType.STANDARD
    , IntegrationType.SAMBA
    , IntegrationType.ELASTICSEARCH_WATCHER
    , IntegrationType.SCOUTER
    , IntegrationType.WHATAP
    , IntegrationType.NIFFLER
    , IntegrationType.ZENIUS
    , IntegrationType.ZMON
    , IntegrationType.JIRA
    , IntegrationType.JIRA_SOFTWARE
    , IntegrationType.FRESHDESK
    , IntegrationType.OPSNOW
    , IntegrationType.IOTOPS
    , IntegrationType.DEVOS
    , IntegrationType.SENTRY_METRIC_ALERT
    , IntegrationType.SENTRY_ISSUE_ALERT
    , IntegrationType.SENTRY_INSTALLATION
    , IntegrationType.SENTRY_ISSUES
    , IntegrationType.SENTRY_COMMENTS
    , IntegrationType.SENTRY_ERRORS
];

export const DetailUseItgr = [
    IntegrationType.JIRA,
    IntegrationType.JIRA_SOFTWARE,
    IntegrationType.FRESHDESK
];

// 앞의 키값을 숫자가 아니라 enum타입 값으로 할 수 있는지..
export const IntegrationName = {
    10035: 'MK.01926'
  , 10039: 'MK.01959'
  , 10036: 'MK.01945'
};

export const IntegrationDetailLabel = {
    10035: 'MK.01928'
    , 10039: 'MK.01928'
    , 10036: 'MK.01947'
};

export const custmSmryUseItgrStr = {
      10008: 'datadog'
    , 10011: 'newrelic'
    , 10013: 'jennifer'
    , 10010: 'prometheus'
    , 10012: 'dynatrace'
    , 10018: 'standard'
    , 10019: 'samba'
    , 10021: 'watcher'
    , 10024: 'scouter'
    , 10005: 'whatap'
    , 10027: 'niffler'
    , 10028: 'zenius'
    , 10029: 'zmon'
    , 10035: 'jira'
    , 10036: 'freshdesk'
    , 10039: 'jira_software'
    , 10038: 'opsnow'
    , 10040: 'iotops'
    , 10041: 'devos'
    , 10044: 'sentry_metric_alert'
    , 10045: 'sentry_issue_alert'
    , 10046: 'sentry_installation'
    , 10047: 'sentry_issues'
    , 10048: 'sentry_comments'
    , 10049: 'sentry_errors'
    };

export const custmSmrySample = {
    datadog : {"sample":datadogSample, "view": datadogSample},
    newrelic : {"sample":newRelicSample, "view":newRelicViewSample},
    jennifer : {"sample":jenniferSample, "view":jenniferViewSample},
    prometheus: null,
    dynatrace: {"sample":dynatraceSample, "view":dynatraceViewSample},
    standard: {"sample":standardSample, "view":standardViewSample},
    samba: {"sample":sambaSample, "view":sambaViewSample},
    watcher: {"sample":watcherSample, "view":watcherViewSample},
    scouter: {"sample":scouterSample, "view":scouterSample},
    whatap: {"sample":whatapSample, "view":whatapSample},
    niffler: {"sample":standardSample, "view":standardViewSample},
    zenius: {"sample":standardSample, "view":standardViewSample},
    zmon: {"sample":standardSample, "view":standardViewSample},
    jira: {"sample":jiraSample, "view":jiraViewSample},
    freshdesk: {"sample":freshdeskSample, "view":freshdeskViewSample},
    jira_software: {"sample":jiraSoftwareSample, "view":jiraSoftwareViewSample},
    opsnow: {"sample":opsnowSample, "view":opsnowViewSample},
    iotops: {"sample":iotOpsSample, "view": iotOsViewSample},
    devos: {"sample":devOsSample, "view":devOsViewSample},
    sentry_metric_alert: {"sample":sentryMetricAlertSample, "view":sentryMetricAlertViewSample},
    sentry_issue_alert: {"sample":sentryIssueAlertSample, "view":sentryIssueAlertViewSample},
    sentry_installation: {"sample":sentryInstallationSample, "view":sentryInstallationViewSample},
    sentry_issues: {"sample":sentryIssuesSample, "view":sentryIssuesViewSample},
    sentry_comments: {"sample":sentryCommentsSample, "view":sentryCommentsViewSample},
    sentry_errors: {"sample": sentryErrorsSample, "view": sentryErrorsViewSample}
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/integration.config.ts